import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const FooterFlowers = () => {
    const [flowers, setFlowers] = useState([]);
    const location = useLocation();
    // Available plant IDs based on actual files in the plantSvgs folder
    const availablePlants = [1, 3, 5, 6, 7, 8, 10, 12, 14, 16];
    const generateFlowers = () => {
        const newFlowers = [];
        // Generate 1 flower 80% of the time, 2 flowers 20% of the time
        const numFlowers = Math.random() < 0.8 ? 1 : 2;
        for (let i = 0; i < numFlowers; i++) {
            const randomPlantIndex = Math.floor(Math.random() * availablePlants.length);
            const plantId = availablePlants[randomPlantIndex];
            newFlowers.push({
                id: i,
                left: Math.random() * 100,
                size: Math.random() * 40 + 30,
                delay: Math.random() * 2,
                plantId: plantId
            });
        }
        setFlowers(newFlowers);
    };
    useEffect(() => {
        generateFlowers();
    }, [location.pathname]);
    return (_jsx("div", { className: "footer-flowers", children: flowers.map((flower) => (_jsx("div", { className: "footer-flower", style: {
                left: `${flower.left}%`,
                width: `${flower.size}px`,
                height: `${flower.size}px`,
                animationDelay: `${flower.delay}s`
            }, children: _jsx("img", { src: `/assets/plantSvgs/plant_${flower.plantId}.svg`, alt: "Decorative plant", className: "flower-svg" }) }, `${location.pathname}-${flower.id}`))) }));
};
export default FooterFlowers;
